var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 9.00063C12.6 8.47563 12.3975 7.95062 12 7.55312L7.10998 2.66312C6.89248 2.44562 6.53248 2.44562 6.31498 2.66313C6.09748 2.88063 6.09748 3.24063 6.31498 3.45813L11.205 8.34812C11.565 8.70812 11.565 9.29312 11.205 9.65313L6.31498 14.5431C6.09748 14.7606 6.09748 15.1206 6.31498 15.3381C6.53248 15.5556 6.89248 15.5556 7.10998 15.3381L12 10.4481C12.3975 10.0506 12.6 9.52562 12.6 9.00063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.e5c58e44be82fb9eaebcb9106a76d1d2.svg";
export { ForwardRef as ReactComponent };